export default "__VITE_ASSET__BBg2rqIL__"